// extracted by css-extract-rspack-plugin
export default {"pickerButton":"f06Ed","secondaryText":"hHjM2"};